import clsx from 'clsx';
import { ASSET_PREFIX } from 'utils/constants';
import styles from './genericModal.module.css';

interface GenericModalProps {
  children: React.ReactNode;
  onClose?: () => void;
  withCloseButton?: boolean;
  style?: Record<string, unknown>;
  /** Text and content alignment - 'left', or defaults to center if unspecified */
  align?: string;
  ariaLabelledByElementId?: string;
  noTextStyleOverrides?: boolean;
}

const GenericModal = ({
  children,
  onClose,
  withCloseButton = true,
  style = undefined,
  align = 'left',
  ariaLabelledByElementId = undefined,
  noTextStyleOverrides = false,
}: GenericModalProps) => (
  <div
    className={clsx(
      styles.container,
      align === 'left' ? styles.containerLeft : '',
    )}
  >
    <div
      className={styles.backdrop}
      onClick={() => onClose && onClose()}
      aria-hidden="true"
    />
    <div
      id="message"
      className={clsx(
        styles.message,
        noTextStyleOverrides ? '' : styles.overrideFont,
      )}
      style={{ ...style }}
      role="dialog"
      aria-labelledby={ariaLabelledByElementId}
    >
      {onClose && withCloseButton && (
        <img
          id="closeButton"
          className={styles.closeButton}
          src={`${ASSET_PREFIX}/images/close_button.svg`}
          style={{ cursor: 'pointer', width: '20px' }}
          onClick={onClose}
          alt="close button - cross"
        />
      )}
      {children}
    </div>
  </div>
);

export default GenericModal;
